import React from 'react';
import { useHistory } from 'react-router-dom';
import VideoPlayer from '../player';
import firebase from 'firebase';

const VideoJs = ({
  videoUrl,
  currentTrack,
  currentUser,
  userProfiles,
  setEpisodeIndex,
  setSeriesIndex,
  series,
  episodeIndex,
  seriesLength,
  seriesIndex,
  subtitle,
  id: seriesId,
  setVideoDuration,
  trailerModal,
  setTrailerEnd,
  from,
  playerInstanceReady,
  isGpSubscribed,
  posterUrl,
  hasTvodSub,
  newSeriesSlug
}) => {
  const playerRef = React.useRef(null);
  const history = useHistory();
  const [url, setUrl] = React.useState(videoUrl);
  const [videoEnd, setVideoEnd] = React.useState(false);
  const [showSkipTrailerBtn, setShowSkipTrailerBtn] = React.useState(false);
  const title = window?.platform_info?.title;
  const gpUser = JSON.parse(localStorage.getItem(`gp_user_${title}`));
  const robiUser = JSON.parse(localStorage.getItem(`robi_user_${title}`));
  const blUser = JSON.parse(localStorage.getItem(`bl_user_${title}`));
  const [playerReady, setPlayerReady] = React.useState(false);
  const isPlayingRef = React.useRef(false);
  const seriesPath = newSeriesSlug
    ? `/content/play/series/${newSeriesSlug}`
    : `/series/${seriesId}`;

  const subTitles =
    subtitle?.length > 0 &&
    subtitle.map((sub) => {
      console.log(`https://subtitles.rockstreamer.com/${sub.path}`);
      return {
        src: `https://subtitles.rockstreamer.com/${sub.path}`,
        kind: 'subtitles',
        srclang: sub.languageCode,
        label: sub.languageCode
      };
    });
  React.useEffect(() => {
    setUrl(videoUrl);
  }, [videoUrl]);

  /* Handle beforeunload to log data if the video was playing
   *  Until closing browser tab
   */
  React.useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isPlayingRef.current) {
        analytics.logEvent('content_tracking_play', {
          content_id: currentTrack?.id.toString(),
          platform_name: window.platform_info.api_key,
          content_duration: playerRef.current.currentTime()
        });
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  /* to log data if the video was playing
   *  Until swap minimize which triggers inactive tab
   */
  React.useEffect(() => {
    if (isPlayingRef.current) {
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          // tab is changed
          analytics.logEvent('content_tracking_play', {
            content_id: currentTrack?.id.toString(),
            platform_name: window.platform_info.api_key,
            content_duration: playerRef.current.currentTime()
          });
        } else {
          // tab is active
        }
      });
    }
  }, []);

  /*
   *  Following effect calls when video ends
   *
   *  "from" parameter indicates only Slug based(v2) details page
   *  -> Having legacy backward compatibility for old id based(v1) details page,
   *     in addition making it work with redesigned details and player (v3) version
   *     which is again inspired from old query param based (v1) series player
   *     Changed lines in v3 can be found by searching
   *     "both v3 and v1 compatible"
   */
  React.useEffect(() => {
    if (videoEnd === true) {
      if (currentTrack?.type === 'catchupTV' || currentTrack?.type === 'catchupTVEpisode') {
        setEpisodeIndex((prev) => prev + 1);
        history.push({
          pathname: `/catchupTV/${seriesId}`,
          search: '?' + new URLSearchParams({ episode_index: episodeIndex + 2 }).toString()
        });
      } else {
        setEpisodeIndex((prev) => prev + 1);
        // both v3 and v1 compatible
        if (!from) {
          history.push({
            pathname: seriesPath,
            search:
              '?' +
              new URLSearchParams({ season_index: 1 }).toString() +
              '&' +
              new URLSearchParams({ episode_index: episodeIndex + 2 }).toString()
          });
        }
        if (episodeIndex == series.contents.length - 1) {
          setSeriesIndex((prev) => prev + 1);
          setEpisodeIndex(0);
          // both v3 and v1 compatible
          if (!from) {
            history.push({
              pathname: seriesPath,
              search:
                '?' +
                new URLSearchParams({ season_index: seriesIndex + 2 }).toString() +
                '&' +
                new URLSearchParams({ episode_index: 1 }).toString()
            });
          }

          if (seriesIndex == seriesLength - 1) {
            // both v3 and v1 compatible
            if (!from) {
              history.push({
                pathname: seriesPath,
                search:
                  '?' +
                  new URLSearchParams({ season_index: 1 }).toString() +
                  '&' +
                  new URLSearchParams({ episode_index: 1 }).toString()
              });
            }
            setSeriesIndex(0);
            setEpisodeIndex(0);
          }
        }
      }
      setVideoEnd(false);
    }
  }, [videoEnd]);

  /*
   *  Following function calls when Skip Episode button in player get clicked
   *
   *  "from" parameter indicates only Slug based(v2) details page
   *  -> Having Legacy backward compatibility for old id based(v1) details page,
   *     in addition making it work with redesigned details and player (v3) version
   *     which is again inspired from old query param based (v1) series player
   *     Changed lines in v3 can be found by searching
   *     "both v3 and v1 compatible"
   */
  function onSkipEpisode() {
    const searchParams = new URLSearchParams(location.search);
    const episodeParamIndex = searchParams.get('episode_index');
    const seasonParamIndex = searchParams.get('season_index');
    setEpisodeIndex((prev) => prev + 1);
    // both v3 and v1 compatible
    if (!from) {
      history.push({
        pathname: seriesPath,
        search:
          '?' +
          new URLSearchParams({ season_index: 1 }).toString() +
          '&' +
          new URLSearchParams({ episode_index: Number(episodeParamIndex) + 1 }).toString()
      });
    }
    if (episodeIndex == series.contents.length - 1) {
      setSeriesIndex((prev) => prev + 1);
      setEpisodeIndex(0);
      // both v3 and v1 compatible
      if (!from) {
        history.push({
          pathname: seriesPath,
          search:
            '?' +
            new URLSearchParams({ season_index: Number(seasonParamIndex) + 1 }).toString() +
            '&' +
            new URLSearchParams({ episode_index: 1 }).toString()
        });
      }

      if (seriesIndex == seriesLength - 1) {
        // both v3 and v1 compatible
        if (!from) {
          history.push({
            pathname: seriesPath,
            search:
              '?' +
              new URLSearchParams({ season_index: 1 }).toString() +
              '&' +
              new URLSearchParams({ episode_index: 1 }).toString()
          });
        }
        setSeriesIndex(0);
        setEpisodeIndex(0);
      }
    }
  }

  React.useEffect(() => {
    if ((gpUser || blUser) && isGpSubscribed === 'OK') {
      setShowSkipTrailerBtn(false);
    } else if (
      currentTrack?.premium &&
      !userProfiles?.subscribe &&
      currentTrack?.trailer &&
      !currentTrack?.tvod
    ) {
      setShowSkipTrailerBtn(true);
    }
  }, [isGpSubscribed]);

  React.useEffect(() => {
    return () => {
      if (showSkipTrailerBtn == true) {
        setShowSkipTrailerBtn(false);
      }
    };
  }, []);

  const onHideSkipTrailer = () => {
    setTrailerEnd(true);
    setShowSkipTrailerBtn(false);
  };

  React.useEffect(() => {
    const handlePopState = () => {
      // window.location.replace(
      //   `https://youtube.com`
      // );
      if (
        playerReady &&
        (gpUser?.partner == 'GP_MYGP' ||
          robiUser?.partner == 'ROBI_MYROBI' ||
          blUser?.partner == 'BANGLALINK_MYBL') &&
        playerRef.current.isFullscreen()
      ) {
        playerRef.current.exitFullscreen();
      }
    };
    if (
      (gpUser?.partner == 'GP_MYGP' ||
        robiUser?.partner == 'ROBI_MYROBI' ||
        blUser?.partner == 'BANGLALINK_MYBL') &&
      window.history.length == 2
    ) {
      window.history.pushState(null, null, document.URL);
    }
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [playerReady]);

  const autoplayStatus =
    currentTrack?.live ||
    currentTrack?.type == 'tv' ||
    (gpUser?.partner == 'GP_MYGP' && currentTrack?.tvodexclusive && hasTvodSub)
      ? true
      : gpUser?.partner == 'GP_MYGP' ||
        robiUser?.partner == 'ROBI_MYROBI' ||
        blUser?.partner == 'BANGLALINK_MYBL'
      ? false
      : !trailerModal;

  // const overrideNative = /iPad|iPhone|iPod/.test(window.navigator.userAgent) && !window.MSStream;
  const overrideNative = false;

  const videoJsOptions = {
    // lookup the options in the docs for more options
    nativeVideoTracks: !overrideNative,
    nativeAudioTracks: !overrideNative,
    nativeTextTracks: !overrideNative,
    autoplay: autoplayStatus,
    // autoplay: false,
    playsinline: true,
    crossorigin: 'anonymous',
    controls: true,
    responsive: true,
    poster: `${process.env.REACT_APP_IMAGE_URL}400xauto/${posterUrl}`,
    sources: [
      {
        src: url,
        type: 'application/x-mpegURL',
        label: 'SD'
      },
      {
        src: url,
        type: 'application/x-mpegURL',
        label: 'HD'
      }
    ],
    userActions: {
      hotkeys: {}
    },
    tracks: subTitles,
    preload: 'auto',
    liveui: true,
    html5: {
      vhs: {
        enableLowLatency: true, // If applicable
        maxBufferLength: 60,
        startLevel: 0, // Automatically choose the best available quality
        limitRenditionByPlayerDimensions: false,
        useDevicePixelRatio: false,
        bandwidth: 500000, // (~0.5 Mbps) forces a conservative start
        overrideNative: true,
        debug: false
      }
    },
    plugins: {
      mux: {
        debug: false,
        data: {
          env_key: 'iljf25jpf0nellio2h5hfo9lt', // required
          // Site Metadata
          video_id: currentTrack?.id,
          video_title: currentTrack?.title
        }
      },
      httpSourceSelector: {
        default: 'low'
      }
    }

    // tracks: [
    //   {
    //     src: 'https://kot-politiken.s3-eu-west-1.amazonaws.com/2019/114_en.vtt.txt',
    //     kind: 'subtitles',
    //     srclang: 'en',
    //     label: 'English'
    //   },
    //   { src: 'https://domain/mysub.vtt', kind: 'subtitles', srclang: 'ban', label: 'Bangla' }
    // ]
  };

  const analytics = firebase.analytics();
  const handlePlayerReady = (player) => {
    playerRef.current = player;
    playerInstanceReady(player);
    console.log('Analytics logging event');
    analytics.logEvent('content_tracking', {
      content_id: currentTrack?.id.toString(),
      platform_name: window.platform_info.api_key,
      content_name: currentTrack?.title,
      type: currentTrack?.type,
      cast: currentTrack?.casts?.map((cast) => cast.name).join(','),
      createdAt: currentTrack?.createdAt,
      user_id: currentUser?.id
    });

    player.on('dispose', () => {
      analytics.logEvent('content_tracking_play', {
        content_id: currentTrack?.id.toString(),
        platform_name: window.platform_info.api_key,
        content_duration: playerRef.current.currentTime()
      });
    });

    player.on('ready', () => {
      console.log('Player is ready');
      setPlayerReady(true);
    });

    player.on('play', () => {
      const gpUser = JSON.parse(localStorage.getItem(`gp_user_${title}`));
      const robiUser = JSON.parse(localStorage.getItem(`robi_user_${title}`));
      const blUser = JSON.parse(localStorage.getItem(`bl_user_${title}`));
      const userAgent = navigator.userAgent;
      if (
        gpUser?.partner == 'GP_MYGP' ||
        robiUser?.partner == 'ROBI_MYROBI' ||
        blUser?.partner == 'BANGLALINK_MYBL'
      ) {
        console.log('Content Playing event');
        player.requestFullscreen();
        player.isFullscreen(true);
      }
      isPlayingRef.current = true;
      console.log('IsplayingRef in play', isPlayingRef);
    });

    player.on('pause', () => {
      isPlayingRef.current = false;
      console.log('IsplayingRef in pause', isPlayingRef);
    });

    player.on('fullscreenchange', () => {
      console.log('Checking full screen event');
    });

    // you can handle player events here
    player.on('waiting', () => {
      console.log('player is waiting');
    });

    player.on('adend', function () {
      console.log('Content resumed');
      player.play();
      player.muted(false);
      // player.volume(100);
    });
  };

  const onVideoEnd = () => {
    if (
      (currentTrack?.premium && !userProfiles?.subscribe) ||
      (currentTrack?.tvod && !userProfiles?.subscribe) ||
      (currentTrack?.tvodexclusive && !hasTvodSub)
    ) {
      setTrailerEnd(true);
    }
    analytics.logEvent('content_tracking_play', {
      content_id: currentTrack?.id.toString(),
      platform_name: window.platform_info.api_key,
      content_duration: playerRef.current.duration()
    });
    setEpisodeIndex && setVideoEnd(true);
  };

  return (
    <VideoPlayer
      options={videoJsOptions}
      onEnd={onVideoEnd}
      currentTrack={currentTrack}
      userProfiles={userProfiles}
      onReady={handlePlayerReady}
      setVideoDuration={setVideoDuration}
      onSkipEpisode={onSkipEpisode}
      seriesId={seriesId}
      showSkipTrailerBtn={showSkipTrailerBtn}
      onHideSkipTrailer={onHideSkipTrailer}
      seriesIndex={seriesIndex}
      episodeIndex={episodeIndex}
      from={from}
      setEpisodeIndex={setEpisodeIndex}
      setSeriesIndex={setSeriesIndex}
      newSeriesSlug={newSeriesSlug}
      autoplayStatus={autoplayStatus}
    />
  );
};

export default VideoJs;
